import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import formatters from '@/modules/laudos/utils/formatters';

export default {
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        }
    },

    computed: {
        camposLaudo() {
            if (!this.informacoesLaudo) return {};

            switch (this.tipoLaudo) {
                case TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG:
                    return {
                        nomeTerritorio: this.informacoesLaudo.nomeTerritorio,
                        observacao: this.informacoesLaudo?.observacao || '-',
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada,
                        areaTerritorio: formatters.formatNumber(
                            this.informacoesLaudo.areaTerritorio
                        ),
                        carsVinculados:
                            this.informacoesLaudo.carsTerritorio?.map(
                                car => car.codigo
                            ),
                        representantesTerritorio:
                            this.informacoesLaudo.representantesTerritorio
                    };
                case TipoLaudo.AGRICOLA:
                case TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA:
                case TipoLaudo.PARCERIA_SUSTENTAVEL_RASTREABILIDADE:
                case TipoLaudo.BACEN_140:
                case TipoLaudo.CARBONO:
                case TipoLaudo.DIAGNOSTICO_AGRICOLA:
                case TipoLaudo.HISTORICO_AGRICOLA:
                case TipoLaudo.SUPRESSAO_VEGETAL:
                case TipoLaudo.RELATORIO_TERRITORIAL:
                    return {
                        nomeTerritorio: this.informacoesLaudo.nomeTerritorio,
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada,
                        areaTerritorio: formatters.formatNumber(
                            this.informacoesLaudo.areaTerritorio
                        ),
                        carsVinculados:
                            this.informacoesLaudo.carsTerritorio?.map(
                                car => car.codigo
                            ),
                        representantesTerritorio:
                            this.informacoesLaudo.representantesTerritorio
                    };
                case TipoLaudo.AVALIACAO_SOCIOAMBIENTAL:
                    return {
                        nomeTerritorio: this.informacoesLaudo.nomeTerritorio,
                        camadasLaudo: this.informacoesLaudo.restricao,
                        safraId: this.informacoesLaudo.safraId,
                        safra: this.informacoesLaudo?.safra?.descricao,
                        culturaEsperada:
                            this.informacoesLaudo?.culturaEsperada?.nome,
                        observacao: this.informacoesLaudo?.observacao || '-',
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada,
                        areaTerritorio: formatters.formatNumber(
                            this.informacoesLaudo.areaTerritorio
                        ),
                        carsVinculados:
                            this.informacoesLaudo.carsTerritorio?.map(
                                car => car.codigo
                            ),
                        representantesTerritorio:
                            this.informacoesLaudo.representantesTerritorio
                    };
                case TipoLaudo.DINAMICA_EXPLORACAO:
                    return {
                        nomeTerritorio: this.informacoesLaudo.nomeTerritorio,
                        camadasLaudo: this.informacoesLaudo.restricao,
                        safra: this.informacoesLaudo?.safra?.descricao,
                        culturaEsperada:
                            this.informacoesLaudo?.culturaEsperada?.nome,

                        dataInicioCoberturaFormatada:
                            this.informacoesLaudo?.dataInicioCoberturaFormatada,
                        dataFimCoberturaFormatada:
                            this.informacoesLaudo?.dataFimCoberturaFormatada,

                        observacao: this.informacoesLaudo.observacao || '-',
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada,
                        areaTerritorio: formatters.formatNumber(
                            this.informacoesLaudo.areaTerritorio
                        ),
                        carsVinculados:
                            this.informacoesLaudo.carsTerritorio?.map(
                                car => car.codigo
                            ),
                        representantesTerritorio:
                            this.informacoesLaudo.representantesTerritorio
                    };
                case TipoLaudo.AVALIACAO_FUNDIARIA:
                    return {
                        nomeTerritorio: this.informacoesLaudo.nomeTerritorio,
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada,
                        descricao: this.informacoesLaudo.descricao || '-',
                        arquivosLaudos: this.informacoesLaudo.arquivosLaudos
                    };
                case TipoLaudo.BACEN_FISCALIZACAO:
                    return {
                        nomeTerritorio: this.informacoesLaudo.nomeTerritorio,
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada,
                        nomeRepresentante:
                            this.informacoesLaudo.nomeRepresentante,
                        cpfCnpjRepresentante:
                            formatters.numeralStringFormatToDocumento(
                                this.informacoesLaudo.cpfCnpjRepresentante
                            ),
                        referenciaBacen: this.informacoesLaudo.referenciaBacen,
                        culturaEsperada:
                            this.informacoesLaudo.culturaEsperada?.nome,
                        areaFinanciadaHa: formatters.formatNumber(
                            this.informacoesLaudo.areaFinanciadaHa
                        ),
                        producaoEsperadaTon: formatters.formatNumber(
                            this.informacoesLaudo.producaoEsperadaTon
                        ),
                        produtividadeEsperadaScHa: formatters.formatNumber(
                            this.informacoesLaudo.produtividadeEsperadaScHa
                        ),
                        dataPlantioFormatado:
                            this.informacoesLaudo.dataPlantioFormatado,
                        dataColheitaFormatado:
                            this.informacoesLaudo.dataColheitaFormatado
                    };
                case TipoLaudo.BENFEITORIAS:
                    return {
                        nomeTerritorio: this.informacoesLaudo.nomeTerritorio,
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada,
                        nomeRepresentante:
                            this.informacoesLaudo.nomeRepresentante,
                        cpfCnpjRepresentante:
                            formatters.numeralStringFormatToDocumento(
                                this.informacoesLaudo.cpfCnpjRepresentante
                            ),
                        dataReferenciaFormatado:
                            this.informacoesLaudo.dataReferenciaFormatado,
                        numeroOperacao:
                            this.informacoesLaudo.numeroOperacao ??
                            this.$t('laudos.naoInserido'),
                        tipoEmpreendimento:
                            this.informacoesLaudo.tipoEmpreendimento ??
                            this.$t('laudos.naoInserido'),
                        arquivosLaudos:
                            this.informacoesLaudo.arquivosLaudos || []
                    };
                case TipoLaudo.CROQUI_LOCALIZACAO:
                    return {
                        baseDados: this.informacoesLaudo.baseDados || '-',
                        tipoInsumo: this.informacoesLaudo.tipoInsumo || '-',
                        nomeTerritorio:
                            this.informacoesLaudo.nomeTerritorio || '-',
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada || null,
                        nomeRepresentante:
                            this.informacoesLaudo.nomeRepresentante,
                        cpfCnpjRepresentante:
                            formatters.numeralStringFormatToDocumento(
                                this.informacoesLaudo.cpfCnpjRepresentante
                            ),
                        proprietarios:
                            this.informacoesLaudo.proprietarios || [],
                        matricula:
                            this.informacoesLaudo.matriculas &&
                            this.informacoesLaudo.matriculas[0]
                                ? this.informacoesLaudo.matriculas[0]
                                : '-',
                        cpr: this.informacoesLaudo.cpr || '-',
                        areaPenhor: this.informacoesLaudo.areaPenhor || '-',
                        qdeEmitentes: this.informacoesLaudo.qdeEmitentes || '-',
                        formatoCoordenadas:
                            this.informacoesLaudo.formatoCoordenadas || '-',
                        carsTerritorio:
                            this.informacoesLaudo.carsTerritorio || []
                    };
                case TipoLaudo.TECNICO_AGRICOLA:
                    return {
                        nomeTerritorio:
                            this.informacoesLaudo.nomeTerritorio || '-',
                        localidadeTerritorio:
                            this.informacoesLaudo.localidadeTerritorio
                                ?.localidadeFormatada || null,
                        nomeRepresentante:
                            this.informacoesLaudo.nomeRepresentante,
                        cpfCnpjRepresentante:
                            formatters.numeralStringFormatToDocumento(
                                this.informacoesLaudo.cpfCnpjRepresentante
                            ),
                        nomeCredor: this.informacoesLaudo.nomeCredor,
                        cpfCnpjCredor:
                            formatters.numeralStringFormatToDocumento(
                                this.informacoesLaudo.cpfCnpjCredor
                            ),
                        emitente: true
                    };
                case TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO:
                    return {
                        areaFinanciadaHa: formatters.formatNumber(
                            this.informacoesLaudo.areaFinanciadaHa
                        ),
                        carsVinculados:
                            this.informacoesLaudo.carsVinculadosCodigos,
                        culturaEsperada:
                            this.informacoesLaudo.culturaEsperada?.nome || '-',
                        dataInicioCobertura:
                            this.informacoesLaudo.dataInicioCoberturaFormatada,
                        dataFimCobertura:
                            this.informacoesLaudo.dataFimCoberturaFormatada
                    };
                default:
                    return {};
            }
        }
    },

    methods: {
        formatarData(d) {
            if (!d) return '-';

            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();

            return `${day}/${month}/${year}`;
        },
        formatarDocumento(documento) {
            return formatters.numeralStringFormatToDocumento(documento);
        },
        formatNumber(number) {
            return number ? number.toFixed(2) : null;
        }
    }
};
